export const closeInlineForms = (container=document) => {
  const button = container.querySelector('.add-message-btn')
  if (button) button.disabled = false;
  [...container.querySelectorAll('.message-form-remote')].forEach(form => {
    const url = form.parentNode.dataset['messages-FormRenderUrl']
    App.Helpers.ajaxRequest({ url, successHandler: res => renderMessage(form, res) });
  })
}

export const renderMessage = (el, { html, isReply, isEdit, url, isParentDelete }) => {
  if (html) {
    (isReply || isEdit) ? (el.closest('.messages--message-div').innerHTML = html) : prependNewMessage({ messageFeed: messageFeedFor(el), html, url })
  }
  isParentDelete && el.closest('.messages--message-div').remove()
  el.closest('.inline-msg-container').remove()
}

export const prependToMessageList = (el, container=document) => {
  const msgList = container.querySelector(".messages--messages-to-display")
  msgList.insertBefore(el, msgList.children[0])
}

export const addFormHandlers = newMsg => {
  const form = newMsg.querySelector('.message-form-remote')
  form.querySelector('trix-editor').addEventListener('trix-change', markDirtyParentForm)
  updateDraft(form)
  App.addHandlers(newMsg)
}

export const updateDraft = (form, skipTimeout=false) => {
  const saveBtn = form.querySelector('.message-save');
  const cancelBtn = form.querySelector('.btn-cancel');
  if ((skipTimeout || form.classList.contains('dirty-form')) && saveBtn && cancelBtn &&
    !(saveBtn.dataset.submitted || cancelBtn.dataset.canceled)) {
    form.classList.remove('dirty-form')
    App.Helpers.ajaxRequest({
      url: '/drafts',
      method: 'POST',
      data: App.Helpers.formDataAsString(form).replace(/_method/g, 'ignore'), // Don't pass in _method since that may change post to patch
      successHandler: () => setTimeout(() => updateDraft(form), 5000)
    })
  } else {
    setTimeout(() => updateDraft(form), 5000)
  }
}

export const messageFeedFor = el => el.closest(".messages--messageable-message-feed--component");

const markDirtyParentForm = event => {
  const field = event.currentTarget
  field.closest('form').classList.add('dirty-form')
}

const prependNewMessage = ({ messageFeed, html, url }) => {
  const newEl = document.createElement('div')
  newEl.className = "display-card messages--message-div with-shadow"
  newEl.setAttribute('data-controller', 'message')
  newEl.setAttribute('data-message-url', url)
  newEl.innerHTML = html
  prependToMessageList(newEl, messageFeed)
  document.getElementById('add-message-btn').disabled = false
}



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/messages/messageHelpers.js